import React, { useRef, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../../../App.css";
import "../../../_Shared/utility.css";
import "./FRHCPModal.css";
import { Button } from "../../../Button/Button";
import { ModalContext } from "../../../../regionLayouts/FRLayout";

function HCPModal() {
  const [isHCPModalVisible, setIsHCPModalVisible] = useContext(ModalContext);
  const yesRadioButtonRef = useRef(null);
  const noRadioButtonRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const contentPages = [
      "/fr",
      "/fr/clinicalevidence",
      "/fr/events",
      "/fr/whyvnotes",
      "/fr/patientresources",
      "/fr/patientstestimonials",
      "/fr/hcptestimonials",
      "/fr/contactus",
      "/fr/privacypolicy",
      "/fr/legalnotice",
    ];

    const refPages = ["/fr/clinicalevidence/", "/fr/whyvnotes/"];

    const contentPathRegex = new RegExp(
      `^(${contentPages.join("|")})(/)?$`,
      "i"
    );
    const refPathRegex = new RegExp(`^(${refPages.join("|")})`, "i");

    const contentPathMatch = contentPathRegex.test(location.pathname);
    const refPathMatch = refPathRegex.test(location.pathname);

    if (
      sessionStorage.getItem("isHCP") !== "yes" &&
      (contentPathMatch || refPathMatch)
    ) {
      setIsHCPModalVisible(true);
    }

    if (isHCPModalVisible) {
      yesRadioButtonRef.current.checked = false;
      noRadioButtonRef.current.checked = false;
    }
  }, [isHCPModalVisible, setIsHCPModalVisible, location.pathname]);

  function onConfirmSelection() {
    if (yesRadioButtonRef.current.checked || noRadioButtonRef.current.checked) {
      if (yesRadioButtonRef.current.checked) {
        sessionStorage.setItem("isHCP", "yes");
      } else if (noRadioButtonRef.current.checked) {
        sessionStorage.setItem("isHCP", "no");
        history.push("/fr/redirect");
      }

      setIsHCPModalVisible(false);
    }
  }

  return (
    <div
      className={
        isHCPModalVisible
          ? "hcp-modal-background active"
          : "hcp-modal-background"
      }
    >
      <div className="hcp-modal-container">
        <p className="hcp-modal-header">Êtes-vous un professionnel de santé ?</p>

        <div className="hcp-disclaimer">
          <p>
            Les informations contenues dans la page que vous vous apprêtez à 
            consulter sont destinées uniquement aux professionnels de santé.{" "}
          </p>
          <br />
          <p>
            En sélectionnant "Oui" et en cliquant sur le bouton ci-dessous, vous 
            confirmez être un professionnel de santé.
          </p>
        </div>

        <div className="hcp-modal-options-container">
          <div className="radio-button-container">
            <input
              type="radio"
              id="yes"
              name="hcp"
              value="yes"
              ref={yesRadioButtonRef}
            />
            <label className="selection-label" htmlFor="yes">
              Oui, je suis un professionnel de santé.
            </label>
          </div>
          <div className="radio-button-container">
            <input
              type="radio"
              id="no"
              name="hcp"
              value="no"
              ref={noRadioButtonRef}
            />
            <label className="selection-label" htmlFor="no">
              Non, je ne suis pas un professionnel de santé.
            </label>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <Button onClick={onConfirmSelection}>CONFIRMER</Button>
        </div>
      </div>
    </div>
  );
}

export default HCPModal;
